import React, { useState } from 'react';
import LoginUser from '../components/LoginUser';
import UserRegistration from '../components/UserRegistration';

const AuthContainer = () => {
  const [isSignUp, setIsSignUp] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 font-sans">
      
      <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden w-full max-w-4xl min-h-[550px] flex">
        
        {/* --- SIGN UP FORM  */}
        
        <div className={`absolute top-0 h-full transition-all duration-700 ease-in-out w-1/2 flex items-center justify-center
          ${isSignUp ? 'left-1/2 opacity-100 z-20' : 'left-1/2 opacity-0 z-10'}`}>
          <UserRegistration />
        </div>

        {/* --- LOGIN FORM --- */}
        
        <div className={`absolute top-0 h-full transition-all duration-700 ease-in-out w-1/2 flex items-center justify-center
          ${isSignUp ? 'left-0 opacity-0 z-10' : 'left-0 opacity-100 z-20'}`}>
          <LoginUser />
        </div>

        {/* --- OVERLAY --- */}
        
        <div className={`absolute top-0 left-1/2 w-1/2 h-full overflow-hidden transition-transform duration-700 ease-in-out z-50 rounded-l-[100px]
          ${isSignUp ? '-translate-x-full rounded-l-none rounded-r-[100px]' : ''}`}>
          
          <div className={`bg-gradient-to-br from-blue-900 to-blue-800 text-white relative -left-full h-full w-[200%] transform transition-transform duration-700 ease-in-out flex items-center justify-center
            ${isSignUp ? 'translate-x-1/2' : 'translate-x-0'}`}>
            
            {/* Left Panel (Visible when Overlay is on Left side -> prompting Login) */}
            <div className={`w-1/2 flex flex-col items-center justify-center px-12 text-center transition-transform duration-700 ease-in-out transform
              ${isSignUp ? 'translate-x-0' : '-translate-x-[20%]'}`}>
              <h1 className="text-3xl font-bold mb-4">Welcome Back!</h1>
              <p className="mb-8 text-blue-100">To keep connected with your assets, please login with your personal info.</p>
              <button 
                onClick={() => setIsSignUp(false)}
                className="py-3 px-10 border-2 border-white rounded-full font-bold hover:bg-white hover:text-blue-900 transition-colors">
                Sign In
              </button>
            </div>

            {/* Right Panel (Visible when Overlay is on Right side -> prompting Sign Up) */}
            <div className={`w-1/2 flex flex-col items-center justify-center px-12 text-center transition-transform duration-700 ease-in-out transform
              ${isSignUp ? 'translate-x-[20%]' : 'translate-x-0'}`}>
              <h1 className="text-3xl font-bold mb-4">Hello, Friend!</h1>
              <p className="mb-8 text-blue-100">Enter your personal details and start your journey with our IoT platform.</p>
              <button 
                onClick={() => setIsSignUp(true)}
                className="py-3 px-10 border-2 border-white rounded-full font-bold hover:bg-white hover:text-blue-900 transition-colors">
                Sign Up
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default AuthContainer;